var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "height-100x d-flex pt-2",
      staticStyle: { "background-color": "#e9e9e9" },
    },
    [
      _c(
        "div",
        {
          ref: "areaBrowserElem",
          staticClass:
            "left-tree-section d-flex flex-column flex-shrink-0 px-3 overflow-hidden relative",
        },
        [
          _c("JobReportFilterComponent"),
          _c("div", {
            staticClass:
              "resize-control-vertical height-100x job-browser-resizer",
            on: { mousedown: _vm.onBrowserMouseDown },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          ref: "jobListParentElem",
          staticClass: "d-flex flex-column flex-grow-1 px-3 overflow-hidden",
        },
        [
          _c("div", { staticClass: "overflow-auto relative pr-3" }, [
            _c(
              "div",
              { staticClass: "d-flex pb-2" },
              [
                _c(
                  "v-row",
                  { staticClass: "d-flex", attrs: { "no-gutters": "" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "d-flex", attrs: { cols: "12" } },
                      [
                        _c(
                          "base-card",
                          {
                            staticClass:
                              "overflow-hidden d-flex flex-column flex-1 rounded-xl section-border",
                            staticStyle: { "background-color": "#e9e9e9" },
                            attrs: { outlined: "" },
                          },
                          [
                            _c(
                              "v-card-text",
                              {
                                staticClass:
                                  "height-100x width-100x overflow-auto py-1 pt-2 pb-0",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-wrap justify-start mb-3",
                                    staticStyle: { gap: "12px" },
                                  },
                                  [
                                    _c(
                                      "v-card",
                                      {
                                        staticClass:
                                          "report-action-card rounded-lg",
                                        attrs: { outlined: "" },
                                      },
                                      [
                                        _c(
                                          "v-list-item",
                                          { attrs: { "two-line": "" } },
                                          [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass: "text-h6 mb-1",
                                                  },
                                                  [_vm._v("Site Information")]
                                                ),
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass:
                                                      "text-h5 font-weight-bold mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.reportsStatistics[
                                                            "SITE_INFORMATION_REPORT"
                                                          ]
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("v-list-item-subtitle", [
                                                  _vm._v("reports"),
                                                ]),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-avatar",
                                              {
                                                staticClass:
                                                  "d-flex align-center justify-center rounded-md",
                                                attrs: {
                                                  tile: "",
                                                  size: "37",
                                                  color: "grey",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      size: "24",
                                                      color: "white",
                                                    },
                                                  },
                                                  [_vm._v("mdi-information")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("v-divider"),
                                        _c(
                                          "v-card-actions",
                                          { staticClass: "justify-center" },
                                          [
                                            _c(
                                              "base-btn",
                                              {
                                                staticClass: "w-100",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  text: "",
                                                  color: "primary",
                                                  disabled:
                                                    _vm.$helpers.notHasPermission(
                                                      _vm.$helpers
                                                        .PERMISSION_KEYS
                                                        .REPORTS_EDIT,
                                                      _vm.siteId
                                                    ),
                                                },
                                                on: {
                                                  click:
                                                    _vm.generateSiteInformationReport,
                                                },
                                              },
                                              [_vm._v("Generate Report")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-card",
                                      {
                                        staticClass:
                                          "report-action-card rounded-lg",
                                        attrs: { outlined: "" },
                                      },
                                      [
                                        _c(
                                          "v-list-item",
                                          { attrs: { "two-line": "" } },
                                          [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass: "text-h6 mb-1",
                                                  },
                                                  [_vm._v("Area")]
                                                ),
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass:
                                                      "text-h5 font-weight-bold mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.reportsStatistics[
                                                            "AREA_REPORT"
                                                          ]
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("v-list-item-subtitle", [
                                                  _vm._v("reports"),
                                                ]),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-avatar",
                                              {
                                                staticClass:
                                                  "d-flex align-center justify-center rounded-md",
                                                attrs: {
                                                  tile: "",
                                                  size: "37",
                                                  color: "grey",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      size: "24",
                                                      color: "white",
                                                    },
                                                  },
                                                  [_vm._v("mdi-map")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("v-divider"),
                                        _c(
                                          "v-card-actions",
                                          { staticClass: "justify-center" },
                                          [
                                            _c(
                                              "base-btn",
                                              {
                                                staticClass: "w-100",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  text: "",
                                                  color: "primary",
                                                  disabled:
                                                    _vm.$helpers.notHasPermission(
                                                      _vm.$helpers
                                                        .PERMISSION_KEYS
                                                        .REPORTS_EDIT,
                                                      _vm.siteId
                                                    ),
                                                },
                                                on: {
                                                  click: _vm.generateAreaReport,
                                                },
                                              },
                                              [_vm._v("Generate Report")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-card",
                                      {
                                        staticClass:
                                          "report-action-card rounded-lg",
                                        attrs: { outlined: "" },
                                      },
                                      [
                                        _c(
                                          "v-list-item",
                                          { attrs: { "two-line": "" } },
                                          [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass: "text-h6 mb-1",
                                                  },
                                                  [_vm._v("Equipment")]
                                                ),
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass:
                                                      "text-h5 font-weight-bold mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.reportsStatistics[
                                                            "EQUIPMENT_REPORT"
                                                          ]
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("v-list-item-subtitle", [
                                                  _vm._v("reports"),
                                                ]),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-avatar",
                                              {
                                                staticClass:
                                                  "d-flex align-center justify-center rounded-md",
                                                attrs: {
                                                  tile: "",
                                                  size: "37",
                                                  color: "grey",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      size: "24",
                                                      color: "white",
                                                    },
                                                  },
                                                  [_vm._v("mdi-tools")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("v-divider"),
                                        _c(
                                          "v-card-actions",
                                          { staticClass: "justify-center" },
                                          [
                                            _c(
                                              "base-btn",
                                              {
                                                staticClass: "w-100",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  text: "",
                                                  color: "primary",
                                                  disabled:
                                                    _vm.$helpers.notHasPermission(
                                                      _vm.$helpers
                                                        .PERMISSION_KEYS
                                                        .REPORTS_EDIT,
                                                      _vm.siteId
                                                    ),
                                                },
                                                on: {
                                                  click:
                                                    _vm.generateEquipmentReport,
                                                },
                                              },
                                              [_vm._v("Generate Report")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-card",
                                      {
                                        staticClass:
                                          "report-action-card rounded-lg",
                                        attrs: { outlined: "" },
                                      },
                                      [
                                        _c(
                                          "v-list-item",
                                          { attrs: { "two-line": "" } },
                                          [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass: "text-h6 mb-1",
                                                  },
                                                  [_vm._v("Inspection")]
                                                ),
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass:
                                                      "text-h5 font-weight-bold mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.reportsStatistics[
                                                            "INSPECTION_REPORT"
                                                          ]
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("v-list-item-subtitle", [
                                                  _vm._v("reports"),
                                                ]),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-avatar",
                                              {
                                                staticClass:
                                                  "d-flex align-center justify-center rounded-md",
                                                attrs: {
                                                  tile: "",
                                                  size: "37",
                                                  color: "grey",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      size: "24",
                                                      color: "white",
                                                    },
                                                  },
                                                  [_vm._v("mdi-magnify")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("v-divider"),
                                        _c(
                                          "v-card-actions",
                                          { staticClass: "justify-center" },
                                          [
                                            _c(
                                              "base-btn",
                                              {
                                                staticClass: "w-100",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  text: "",
                                                  color: "primary",
                                                  disabled:
                                                    _vm.$helpers.notHasPermission(
                                                      _vm.$helpers
                                                        .PERMISSION_KEYS
                                                        .REPORTS_EDIT,
                                                      _vm.siteId
                                                    ),
                                                },
                                                on: {
                                                  click:
                                                    _vm.generateInspectionReport,
                                                },
                                              },
                                              [_vm._v("Generate Report")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-card",
                                      {
                                        staticClass:
                                          "report-action-card rounded-lg",
                                        attrs: { outlined: "" },
                                      },
                                      [
                                        _c(
                                          "v-list-item",
                                          { attrs: { "two-line": "" } },
                                          [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass: "text-h6 mb-1",
                                                  },
                                                  [_vm._v("Project")]
                                                ),
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass:
                                                      "text-h5 font-weight-bold mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.reportsStatistics[
                                                            "JOB_REPORT"
                                                          ]
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("v-list-item-subtitle", [
                                                  _vm._v("reports"),
                                                ]),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-avatar",
                                              {
                                                staticClass:
                                                  "d-flex align-center justify-center rounded-md",
                                                attrs: {
                                                  tile: "",
                                                  size: "37",
                                                  color: "grey",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      size: "24",
                                                      color: "white",
                                                    },
                                                  },
                                                  [_vm._v("mdi-folder")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("v-divider"),
                                        _c(
                                          "v-card-actions",
                                          { staticClass: "justify-center" },
                                          [
                                            _c(
                                              "base-btn",
                                              {
                                                staticClass: "w-100",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  text: "",
                                                  color: "primary",
                                                  disabled:
                                                    _vm.$helpers.notHasPermission(
                                                      _vm.$helpers
                                                        .PERMISSION_KEYS
                                                        .REPORTS_EDIT,
                                                      _vm.siteId
                                                    ),
                                                },
                                                on: {
                                                  click:
                                                    _vm.openProjectSelectionDialog,
                                                },
                                              },
                                              [_vm._v("Generate Report")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-card",
                                      {
                                        staticClass:
                                          "report-action-card rounded-lg",
                                        attrs: { outlined: "" },
                                      },
                                      [
                                        _c(
                                          "v-list-item",
                                          { attrs: { "two-line": "" } },
                                          [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass: "text-h6 mb-1",
                                                  },
                                                  [_vm._v("Periodic")]
                                                ),
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass:
                                                      "text-h5 font-weight-bold mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.reportsStatistics[
                                                            "PERIODIC_REPORT"
                                                          ]
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("v-list-item-subtitle", [
                                                  _vm._v("reports"),
                                                ]),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-avatar",
                                              {
                                                staticClass:
                                                  "d-flex align-center justify-center rounded-md",
                                                attrs: {
                                                  tile: "",
                                                  size: "37",
                                                  color: "grey",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      size: "24",
                                                      color: "white",
                                                    },
                                                  },
                                                  [_vm._v("mdi-calendar")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("v-divider"),
                                        _c(
                                          "v-card-actions",
                                          { staticClass: "justify-center" },
                                          [
                                            _c(
                                              "base-btn",
                                              {
                                                staticClass: "w-100",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  text: "",
                                                  color: "primary",
                                                  disabled:
                                                    _vm.$helpers.notHasPermission(
                                                      _vm.$helpers
                                                        .PERMISSION_KEYS
                                                        .REPORTS_EDIT,
                                                      _vm.siteId
                                                    ),
                                                },
                                                on: {
                                                  click:
                                                    _vm.generatePeriodicReport,
                                                },
                                              },
                                              [_vm._v("Generate Report")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-card",
                                      {
                                        staticClass:
                                          "report-action-card rounded-lg",
                                        attrs: { outlined: "" },
                                      },
                                      [
                                        _c(
                                          "v-list-item",
                                          { attrs: { "two-line": "" } },
                                          [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass: "text-h6 mb-1",
                                                  },
                                                  [_vm._v("Intrinsic Safety")]
                                                ),
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass:
                                                      "text-h5 font-weight-bold mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.reportsStatistics[
                                                            "INTRINSIC_SAFETY_REPORT"
                                                          ]
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("v-list-item-subtitle", [
                                                  _vm._v("reports"),
                                                ]),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-avatar",
                                              {
                                                staticClass:
                                                  "d-flex align-center justify-center rounded-md",
                                                attrs: {
                                                  tile: "",
                                                  size: "37",
                                                  color: "grey",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      size: "24",
                                                      color: "white",
                                                    },
                                                  },
                                                  [_vm._v("mdi-shield-check")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("v-divider"),
                                        _c(
                                          "v-card-actions",
                                          { staticClass: "justify-center" },
                                          [
                                            _c(
                                              "base-btn",
                                              {
                                                staticClass: "w-100",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  text: "",
                                                  color: "primary",
                                                  disabled:
                                                    _vm.$helpers.notHasPermission(
                                                      _vm.$helpers
                                                        .PERMISSION_KEYS
                                                        .REPORTS_EDIT,
                                                      _vm.siteId
                                                    ),
                                                },
                                                on: {
                                                  click:
                                                    _vm.generateIntrinsicSafetyReport,
                                                },
                                              },
                                              [_vm._v("Generate Report")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "d-block overflow-hidden mt-4",
                style: {
                  height: _vm.parentHeight
                    ? `${_vm.parentHeight - _vm.currentHeight - 16}px`
                    : "50%",
                  "min-height": "150px",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "overflow-hidden height-100x" },
                  [
                    _c("ReportListingComponent", {
                      ref: "reportListingRef",
                      attrs: { getReportsStatistics: _vm.getReportsStatistics },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]
      ),
      _c("ProjectSelectionDialogComponent", {
        ref: "projectSelectionDialogRef",
        attrs: { siteId: _vm.siteId, readonly: true },
        on: { selected: _vm.projectSelected },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }